module.exports = __webpack_public_path__ + "static/media/fileIcon.a53bea01.svg";